<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { supabase } from '@/supabase'
import Button from 'primevue/button'
import ProgressBar from 'primevue/progressbar'
import Card from 'primevue/card'
import Tag from 'primevue/tag'
import Dialog from 'primevue/dialog';
import Textarea from 'primevue/textarea';
import InputText from 'primevue/inputtext';
import Message from 'primevue/message';
import { formatarDataHora } from '@/utils/formatarDataHora';
import { replaceEspacosPorHTML } from '@/utils/replaceEspacosPorHTML';
import ButtonGroup from 'primevue/buttongroup';
import Editor from 'primevue/editor';

// comentario
const router = useRouter()
const route = useRoute()

const parecer = ref('');
const loading = computed(() => store.state.loading);

function goBack() {
    router.push({ path: '/estudante/aulas/' })
}


const store = useStore()
const aula = computed(() => store.state.aula)

const userSession = store.state.userSession.user.idU;

onMounted(async () => {
    if (aula.value.idDaAula == null || aula.value.idDaAula == undefined || aula.value.idDisciplina == null || aula.value.idDisciplina == undefined || aula.value.idPlano == null || aula.value.idPlano == undefined) {
        router.push({ path: '/estudante/aulas/' })
    }


    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('caderno')
        .select('*')
        .eq('estudante', userSession)
        .eq('aula', aula.value.idDaAula)
        .order('id', { ascending: false })


    if(error){
        console.log(error);
        return;
    }

    anotacoes.value = data



    store.dispatch('updateLoading', false)

})
const visible = ref(false);
const anotacoes = ref([])
const anotacao = ref({
    id: null,
    created_at: null,
    anotacao: '',
    titulo: 'Título',
    estudante: userSession,
    plano: aula.value.idPlano,
    disciplina: aula.value.idDisciplina,
    aula: aula.value.idDaAula
})
function resetAnotacao() {
    anotacao.value = {
        id: null,
        created_at: null,
        anotacao: '',
        titulo: 'Título',
        estudante: userSession,
        plano: aula.value.idPlano,
        disciplina: aula.value.idDisciplina,
        aula: aula.value.idDaAula
    };
}

const hasUnsavedChanges = computed(() => {
    if(anotacao.value.anotacao === ""){
        return false;
    }else{
        return true;
    }
});


window.addEventListener('beforeunload', (event) => {
    console.log(hasUnsavedChanges.value)
    if (hasUnsavedChanges.value) {
        event.preventDefault();
        event.returnValue = '';
    }
});

function beforeCloseModal() {
    if (hasUnsavedChanges.value) {
        const confirmClose = confirm("Há alterações não salvas. Tem certeza de que deseja fechar o modal?");
        if (confirmClose) {
            resetAnotacao();
            return true;
        } else {
            return false;
        }
    } else {
        return true;
    }
}

router.beforeEach((to, from, next) => {
    if (hasUnsavedChanges.value) {
        const confirmLeave = confirm("Há alterações não salvas. Tem certeza de que deseja sair?");
        if (confirmLeave) {
            next(); // Permite a navegação
        } else {
            next(false); // Impede a navegação
        }
    } else {
        next(); // Permite a navegação se não houver alterações não salvas
    }
});

const erroAoSalvarAnotacao = ref(false)
const salvandoAnotacao = ref(false)

async function salvarAnotacao() {
   salvandoAnotacao.value = true

   if(anotacao.value.id != null){
       atualizarAnotacao();
       return;
   }

    const { data, error } = await supabase
        .from('caderno')
        .insert([
            {
                anotacao: anotacao.value.anotacao,
                estudante: anotacao.value.estudante,
                plano: anotacao.value.plano,
                disciplina: anotacao.value.disciplina,
                aula: anotacao.value.aula,
                titulo: anotacao.value.titulo
            }
        ])
        .select()

    if (error) {
        erroAoSalvarAnotacao.value = true;
        salvandoAnotacao.value = false;
        return
    }

    anotacao.value.id = data[0].id
    anotacao.value.created_at = data[0].created_at
    anotacoes.value.unshift({...anotacao.value})

    visible.value = false

    salvandoAnotacao.value = false

    resetAnotacao();
}

async function atualizarAnotacao() {
    const { data, error } = await supabase
        .from('caderno')
        .update([
            {
                anotacao: anotacao.value.anotacao,
                estudante: anotacao.value.estudante,
                plano: anotacao.value.plano,
                disciplina: anotacao.value.disciplina,
                aula: anotacao.value.aula,
                titulo: anotacao.value.titulo
            }
        ])
        .eq('id', anotacao.value.id)
        .select()

    if (error) {
        erroAoSalvarAnotacao.value = true
        return
    }
    let anotacaoAtualizada = anotacoes.value.find(nota => nota.id === anotacao.value.id)
    if(anotacaoAtualizada){
        anotacaoAtualizada.anotacao = anotacao.value.anotacao;
        anotacaoAtualizada.titulo = anotacao.value.titulo;
    }
    salvandoAnotacao.value = false;
    visible.value = false;
    resetAnotacao();

}


function editarAnotacao(data) {
    previnirRemocaoTexo.value = true;
    anotacao.value = { ...data, anotacao: data.anotacao };
    visible.value = true;
    setTimeout(() => {
        previnirRemocaoTexo.value = false;
    }, 0);

}

const anotacaoParaEscluir = ref(null);
const visibleExcluirAnotacao = ref(false);
function confirmarExclusao(id) {
    anotacaoParaEscluir.value = id;
    visibleExcluirAnotacao.value = true

}

const excluindoAnotacao = ref(false);
async function excluirAnotacao() {
    excluindoAnotacao.value = true
    const { error } = await supabase
        .from('caderno')
        .delete()
        .eq('id', anotacaoParaEscluir.value)
    anotacoes.value = anotacoes.value.filter((anotacao) => anotacao.id !== anotacaoParaEscluir.value)
    excluindoAnotacao.value = false
    visibleExcluirAnotacao.value = false

}

const previnirRemocaoTexo = ref(false)
function abrirModalCriarAnotacao() {

    visible.value = true

    anotacao.value = {
        id: null,
        anotacao: '',
        titulo: 'Título',
        estudante: userSession,
        plano: aula.value.idPlano,
        disciplina: aula.value.idDisciplina,
        aula: aula.value.idDaAula
    }

}


let skipNextWatch = false;

watch(() => anotacao.value.anotacao, (newVal, oldVal) => {
    if (previnirRemocaoTexo.value === true){
        return;
    }

    if (skipNextWatch) {
        skipNextWatch = false;
        return;
    }

    if ((newVal.length - oldVal.length) > 100) {

        skipNextWatch = true;

        setTimeout(() => {
            anotacao.value.anotacao = "Escreva seu texto, não cole ele!";
        }, 0);
    }
}, { deep: true });


async function enviarFeedbackdoFeedback(idAnotacao, feedback) {
    const {error} = await supabase .from('caderno').update({'feedback_comentario': feedback}).eq('id', idAnotacao)

    if(error){
        alert('Ocorreu um erro ao enviar o feedback: ' + error.message)
        console.log(error);
        return;
    }

    let anotacao = anotacoes.value.find(nota => nota.id === idAnotacao)
    if(anotacao){
        anotacao.feedback_comentario = feedback
    }
}

</script>

<template>
    <div>
        <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
        <div class="header border-bottom-1 border-200 z-3">
            <div class="text-color text-xl flex align-items-center">
                <Button @click="goBack" icon="pi pi-arrow-left" text rounded aria-label="Filter" severity="secondary" />
                <span class="ml-2">Anotações de {{ aula.disciplina }}</span>

            </div>
        </div>
        <div class="p-4 pt-8 container">
            <div class="flex justify-content-end mb-4">
                <Button icon="pi pi-pencil" @click="abrirModalCriarAnotacao" aria-label="Save" label="Criar Anotação"
                    severity="primary" text />
            </div>



            <div class="flex flex-column gap-5">
                <div v-for="anotacao in anotacoes" :key="anotacao.id" class="bg-white border-round shadow-1">
                    <div class="mb-3 flex justify-content-between align-items-center p-3 md:p-4 pb-0 md:pb-0">
                        <div>
                            <div class="mb-1 top-0 text-xl font-semibold">{{ anotacao.titulo }}</div>
                            <small class="block">{{ formatarDataHora(anotacao.created_at) }}</small>
                        </div>
                        <div>
                            <Button icon="pi pi-pencil" size="small" text severity="secondary"
                                @click="editarAnotacao(anotacao)" />
                            <Button icon="pi pi-trash" size="small" text severity="secondary"
                                @click="confirmarExclusao(anotacao.id)" />
                        </div>
                    </div>
                    <div v-html="replaceEspacosPorHTML(anotacao.anotacao)" class="p-3 md:p-4 pt-0 mb:pt-0"></div>
                    <div class="surface-ground mt-3" v-if="anotacao.comentario">
                        <div class="p-3 md:p-4">
                            <h3 class="mt-0">Feedback</h3>
                            <div v-html="replaceEspacosPorHTML(anotacao.comentario)"></div>
                        </div>
                        <div>
                            <div class="p-3 md:p-4" v-if="anotacao.feedback_comentario == null">
                                <p class="text-center">Esse feedback ajudou você e entender o que precisa fazer melhor?
                                </p>
                                <div class="flex gap-3 justify-content-center">
                                    <Button outlined severity="primary" label="Sim"
                                        @click="enviarFeedbackdoFeedback(anotacao.id, 1)" />
                                    <Button outlined severity="primary" label="Não"
                                        @click="enviarFeedbackdoFeedback(anotacao.id, 2)" />
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <!-- Lista de cards de anotações -->

            </div>

        </div>
    </div>
    <Dialog v-model:visible="visible" modal :header="anotacao.titulo"
        :style="{ width: '100vw', height: '100vh', margin: '0', maxWidth: '100%' }"
        :breakpoints="{ '1199px': '75vw', '575px': '100vw' }">
        <div class="flex flex-column gap-5 mt-1 mb-1 container">
          <Message severity="error">Não cole texto no espaço de anotação, isso vai apagar o que escreveu.</Message>
            <InputText v-model="anotacao.titulo" placeholder="Título" class="w-full" />

            <Textarea v-model="anotacao.anotacao" placeholder="Escreva sua anotação" rows="20" cols="30"
                class="w-full" />

            <Message v-if="erroAoSalvarAnotacao" severity="error">Ocorreu um erro ao salvar sua anotação. Copie o
                conteúdo para não perder, recarregue a página e tente salvar novamente.</Message>
            <Button :label="anotacao.id == null ? 'Criar Anotação' : 'Atualizar Anotação'" class="w-full"
                @click="salvarAnotacao()" :loading="salvandoAnotacao" />
        </div>
    </Dialog>
    <Dialog v-model:visible="visibleExcluirAnotacao" modal :style="{ width: '20rem' }" :closable="false">
        <div class="mb-5">Tem certeza que deseja excluir esta anotação?</div>
        <div class="flex gap-5 mt-1 mb-1">
            <Button severity="danger" icon="pi pi-times" label="Cancelar" @click="visibleExcluirAnotacao = false" />
            <Button severity="danger" icon="pi pi-trash" label="Excluir" text @click="excluirAnotacao()"
                :loading="excluindoAnotacao" />
        </div>
    </Dialog>



</template>

<style>
span.p-tag.p-component.p-tag-rounded.tag-aulas {
    min-width: 55px;
}
</style>
